export default {
      id: "info-usage",
      viewBox: "0 0 18 18",
      url: "/assets/" + "icons.svg#info",
      toString: function () {
        return this.url;
      }
    }